import { H2RInput } from "../../imports";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
    <H2RInput
				label="Line one (Large text)"
				value={cue.text}
        placeholder="Join our Q&A here"
				onChange={(value) => {
					onUpdate({
						text: value,
					});
				}}
			/>
      <H2RInput
				label="Line two (Small text)"
				value={cue.url}
        placeholder="h2r.li/code • [qanda.code]"
				onChange={(value) => {
					onUpdate({
						url: value,
					});
				}}
			/></>
	);
};

export const GraphicCueContent = ({
	cue,
}) => {
	return (
		<div
			className={`overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg overflow-hidden
        `}
		>
			<span className="font-semibold">
				Q&A • Join
			</span>
		</div>
	);
};
